import React, { useRef, useEffect } from 'react';

function Hero() {
  const desktopVideoRef = useRef(null);
  const mobileVideoRef = useRef(null);

  useEffect(() => {
    const playVideos = () => {
      [desktopVideoRef.current, mobileVideoRef.current].forEach((video) => {
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          const promise = video.play();
          if (promise !== undefined) {
            promise.catch(() => {});
          }
        }
      });
    };

    playVideos();

    const handleFirstInteraction = () => {
      playVideos();
      window.removeEventListener('touchstart', handleFirstInteraction);
      window.removeEventListener('click', handleFirstInteraction);
    };
    window.addEventListener('touchstart', handleFirstInteraction, { passive: true });
    window.addEventListener('click', handleFirstInteraction, { passive: true });

    return () => {
      window.removeEventListener('touchstart', handleFirstInteraction);
      window.removeEventListener('click', handleFirstInteraction);
    };
  }, []);

  return (
    <>
      {/* Outer Wrapper for Hero: White space on left & right on Desktop */}
      <div className="w-full bg-white flex justify-center border-b border-brand-200/80 px-4 sm:px-6 lg:px-8">
        <section className="relative w-full max-w-7xl bg-slate-950 overflow-hidden shadow-lg border-x border-slate-200/80">
          <div className="w-full relative aspect-[9/16] max-h-[78vh] sm:max-h-[82vh] min-h-[460px] md:aspect-video md:max-h-[82vh] md:min-h-[420px] flex items-center justify-center">
            
            {/* Top-Center Brand Logo */}
            <div className="absolute top-1 sm:top-2 md:top-3 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center justify-center text-center pointer-events-none select-none px-4">
              <img
                src="/logo.png"
                alt="DA'Vi Logo"
                className="w-28 h-28 sm:w-40 sm:h-40 md:w-52 md:h-52 lg:w-60 lg:h-60 object-contain filter drop-shadow-[0_8px_24px_rgba(0,0,0,0.6)]"
              />
            </div>

            {/* Bottom-Center ORDER NOW Button */}
            <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 z-20">
              <a
                href="#builder"
                className="inline-flex items-center justify-center px-8 py-3 rounded-full text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] bg-brand-600 hover:bg-brand-700 text-white transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Order Now
              </a>
            </div>

            {/* Desktop Video (Horizontal 16:9) */}
            <video
              ref={desktopVideoRef}
              src="/hero/Turn_this_into_slowmo_ads_of_w.mp4"
              poster="/hero.webp"
              autoPlay
              loop
              muted
              defaultMuted
              playsInline
              className="hidden md:block w-full h-full object-cover object-center"
            >
              Your browser does not support the video tag.
            </video>

            {/* Mobile Video (Vertical 9:16) */}
            <video
              ref={mobileVideoRef}
              src="/hero/Make_calming_ads_for_this_pict (1).mp4"
              poster="/hero.webp"
              autoPlay
              loop
              muted
              defaultMuted
              playsInline
              className="block md:hidden w-full h-full object-cover object-center"
            >
              Your browser does not support the video tag.
            </video>

          </div>
        </section>
      </div>
    </>
  );
}

export default Hero;
